import { useLayoutEffect } from 'react'

import { updateToranjaTheme } from 'utils'

import { enableDarkMode, disableDarkMode } from '@interco/inter-ui'
import { IWbAppInfo } from '@interco/inter-webview-bridge'

type DarkModeLoaderProps = {
  appInfo: IWbAppInfo
}

const DarkModeLoader = ({ appInfo }: DarkModeLoaderProps) => {
  useLayoutEffect(() => {
    if (!appInfo.application) return

    if (appInfo.isDarkMode) {
      document.body.style.backgroundColor = '#1C1C1E'
      enableDarkMode()
      localStorage.setItem('isDarkMode', 'true')
    } else {
      document.body.style.backgroundColor = '#FFFFFF'
      disableDarkMode()
      localStorage.setItem('isDarkMode', 'false')
    }

    updateToranjaTheme(appInfo.application, appInfo.isDarkMode)
  }, [appInfo])

  return <div />
}

export default DarkModeLoader
